import type { ComponentProps } from 'react';
import { OwcLogo } from '@one/react';

export type PocLogoProps = ComponentProps<typeof OwcLogo>;

export const PocLogo: React.FC<PocLogoProps> = (props) => <OwcLogo {...props} />;
